import React from 'react';
import { Stack, Spinner, SpinnerSize, Text, MessageBar, MessageBarType } from '@fluentui/react';
import { AssignmentPreviewDto, TimeSearchRow, TimeUser } from '../../../../../api/generated/data-contracts';

interface AssignmentInfoDisplayProps {
    assignmentInfo: AssignmentPreviewDto | null;
    isLoadingPreview: boolean;
    selectedUser: TimeUser | null;
    selectedTask: TimeSearchRow | null;
}

export const AssignmentInfoDisplay: React.FC<AssignmentInfoDisplayProps> = ({ assignmentInfo, isLoadingPreview, selectedUser, selectedTask }) => {
    // Loading spinner while fetching assignment info
    if (selectedUser && selectedTask && isLoadingPreview) {
        return (
            <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
                <Spinner size={SpinnerSize.small} />
                <Text variant="small">Loading assignment information...</Text>
            </Stack>
        );
    }

    // Assignment Rate Information
    if (assignmentInfo) {
        let messageBarType: MessageBarType;
        if (assignmentInfo.hasAssignment) {
            messageBarType = assignmentInfo.rate ? MessageBarType.success : MessageBarType.info;
        } else {
            messageBarType = MessageBarType.info;
        }

        let message: string;
        if (assignmentInfo.hasAssignment) {
            if (assignmentInfo.rate) {
                message = `Assignment rate: ${assignmentInfo.rate} ${
                    assignmentInfo.rateCurrencyCode || ''
                }. You can optionally select an Activity or enter a Custom Rate to override this for invoicing.`;
            } else {
                message = 'Assignment exists but has no rate configured.';
            }
        } else {
            message = 'No assignment found for this user/task combination.';
        }

        return <MessageBar messageBarType={messageBarType}>{message}</MessageBar>;
    }

    return null;
};
